import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionTimerStatus } from '../objects/Session';

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {
  
  sessionTimerStatus: Subject<SessionTimerStatus> = new Subject<SessionTimerStatus>();
  sessionTimerChanged$ = this.sessionTimerStatus.asObservable();

  private keepSessionAlive: Subject<boolean> = new Subject<boolean>();
  keepSessionAliveChanged$ = this.keepSessionAlive.asObservable();

  constructor() { }

  startSessionTimer(){
    this.sessionTimerStatus.next(SessionTimerStatus.START);
  }

  resetSessionTimer(){
    this.sessionTimerStatus.next(SessionTimerStatus.RESET);
  }

  stopSessionTimer(){
    this.sessionTimerStatus.next(SessionTimerStatus.STOP);
  }

  setKeepSessionAlive(keepAlive: boolean){
    this.keepSessionAlive.next(keepAlive);
  }
}
